import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import Urls from 'Containers/Urls';
import fetchEmailVerificationStatus from 'Services/VerifyAccount/Validate';
import { useConfig } from 'Contexts/Config';
import { isMobileDesign } from 'Utils/mobile';
import LoadingRedesign from 'Redesign_Funnel/components/Loading';
import { useGlobalQuery } from 'Hooks/useGlobalQuery';
import { KUESKI_SESSION_STORAGE_KEY } from 'Src/consts/session';

export const EmailVerified: React.FC = ({ children }) => {
  const isMobile = isMobileDesign();
  const history = useHistory();
  const match = useRouteMatch(Urls.startVerification);
  const { features: { VERIFY_ACCOUNT: isVerifyEmail } } = useConfig();

  const isUserVerification = match?.isExact;

  const shouldVerify = Boolean(isVerifyEmail) && !isMobile && !isUserVerification;
  const {
    data: response,
    isFetching,
  } = useGlobalQuery(
    ['EMAIL_VERIFICATION_STATUS'],
    () => {
      if (!localStorage.getItem(KUESKI_SESSION_STORAGE_KEY)) {
        return { data: { force_verify_email: false, is_email_verified: false } };
      }

      return fetchEmailVerificationStatus();
    },
    {
      cacheTime: 0,
      enabled: shouldVerify,
    },
  );

  useEffect(() => {
    if (response?.data) {
      const isEmailVerified = response.data.is_email_verified;
      const forceVerifyEmail = response.data.force_verify_email;

      if (!isEmailVerified && forceVerifyEmail) {
        history.push(`${Urls.verifyAccount}/?send_email=true`);
      }
    }
  }, [response]);

  if (isFetching) return <LoadingRedesign />;

  return <>{response || !shouldVerify ? children : null}</>;
};
